import { centerCrop, makeAspectCrop } from "react-image-crop";

type DrawCanvasParams = {
  image: HTMLImageElement;
  canvas: HTMLCanvasElement;
  x: number;
  y: number;
  width: number;
  height: number;
  scaleFactor?: number;
};

export const drawCanvas = (
  params: DrawCanvasParams
): HTMLCanvasElement | null => {
  const { image, x, y, width, height, scaleFactor = 1 } = params;

  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const croppedWidth = width * scaleFactor;
  const croppedHeight = height * scaleFactor;

  canvas.width = croppedWidth;
  canvas.height = croppedHeight;

  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    x * scaleX,
    y * scaleY,
    width * scaleX,
    height * scaleY,
    0,
    0,
    croppedWidth,
    croppedHeight
  );

  return canvas;
};

export const centerAspectCrop = (params: {
  mediaWidth: number;
  mediaHeight: number;
  aspect: number;
}) => {
  const { mediaWidth, mediaHeight, aspect } = params;
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 100,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
};
